<div [ngClass]="{ 'w-100 p-2 py-4': data?.isSmallScreen || isTablet, 'w-75 p-4': !data?.isSmallScreen && !isTablet }">
  @if (data?.isSmallScreen) {
  <img id="EnergyComparison_YourTariffs_TariffInformation_CloseIcon" src="./assets/ctm-images/close.svg" alt="close"
    class="cy-closeIcon position-absolute end-0 me-2" (click)="closeDialog()">
  }
  @if(data) {
  <app-supplier-tariff class="w-75" [ngClass]="{'w-100': data?.isSmallScreen}" [index]="data?.index"
    [banner]="data?.banner" [supplierDetails]="data?.selectedQuote" [meerkatReward]="data" [source]="'tariffDetails'"
    [isSmallScreen]="data?.isSmallScreen" (close)="closeDialog()"></app-supplier-tariff>
  }
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms" class="ctm-tab"
    [ngClass]="{'equal-width-tabs': data?.isSmallScreen}">
    @if (data?.selectedQuote?.Fuels?.Electricity) {
    <mat-tab [id]="id + '_Electricity'">
      <ng-template mat-tab-label>Electricity</ng-template>

      <div class="m-3">
        <h3 class="fs-20 fw700 mb-3">Tariff information</h3>
        <div class="text-center-xs fs-17">
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }">&nbsp;</div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50"><span class="fw700">New tariff</span></div>
              <div class="w-50"><span class="fw700">Current tariff</span></div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first fw700" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }">Supplier</div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">{{data?.selectedQuote?.SupplierName}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.SupplierName}}
              </div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Tariff</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">{{data?.selectedQuote?.TariffName}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.TarrifName}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Tariff
                type</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">{{data?.selectedQuote?.TarrifType}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.TarrifType}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Payment
                method</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.PaymentMethodText}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.PaymentMethodText}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Unit rate</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.UnitRate}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.UnitRate}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Night rate</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.NightUnitRate}}
                <!-- Off peak timing -->
                @if (data?.selectedQuote?.offPeakRate?.StartTime) {
                <br />
                <span>({{data?.selectedQuote?.offPeakRate?.StartTime}} -
                  {{data?.selectedQuote?.offPeakRate?.EndTime}})</span>
                }
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.NightUnitRate}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Standing
                charges</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.StandingCharge.split('(')[0]}}<br />
                {{data?.selectedQuote?.Fuels?.Electricity?.StandingChargerPerYear}} per year
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.StandingCharge.split('(')[0]}}<br />
                {{currentSupplier?.Fuels?.Electricity?.StandingChargerPerYear}} per year
              </div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Exit fees</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{data?.selectedQuote?.Fuels?.Electricity?.ExitFee}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{currentSupplier?.Fuels?.Electricity?.ExitFees}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Discount and
                additional charges</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.DiscountsAndAdditionalCharges[0].DiscountDesc}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.Discounts === 0 ? '£0' :
                currentSupplier?.Fuels?.Electricity?.Discounts}}
              </div>
            </div>

          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Additional
                products included</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.AdditionalProductsIncluded}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.AdditionalProductsIncluded}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Price guaranteed
                until</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill align-items-center">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.PriceGuaranteedUntil}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.PriceGuaranteedUntil}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Tariff ends
                on</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Electricity?.TarrifEndDate}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Electricity?.TarrifEndDate}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
        </div>
        <div class="pb-0 ">
          <div class="d-none d-md-block">&nbsp;</div>
          <h3 class="fs-20 fw700 mb-3">Your potential savings</h3>
          <div class="d-flex mb-2 gap-4">
            <div class="w44 w-sm-65"><span class="fw700">Your current monthly usage:</span></div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">
              {{elecCurrentUsageMonthly()}} Kwh</div>
          </div>
          <div class="d-flex mb-2 gap-4">
            <div class="w44 w-sm-65"><span class="fw700">Your current monthly payment:</span></div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">
              &pound;{{currentSupplier?.Fuels?.Electricity?.EstimatedMonthlyCost}}</div>
          </div>
          <div class="seprator8 mb-2"></div>
          <div class="d-flex mb-2 gap-4">
            <div class="w44 w-sm-65"><span class="fw700">With this tariff you could pay:</span></div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">
              &pound;{{data?.selectedQuote?.Fuels?.Electricity?.EstimatedMonthlyCost}}</div>
          </div>
          <div class="d-flex mb-3 gap-4">
            <div class="w44 w-sm-65">
              <span class="fw700" *ngIf="!isNegativeNumber(elecSavingPerMonth())">Estimated savings if you
                switch:</span>
              <span class="fw700" *ngIf="isNegativeNumber(elecSavingPerMonth())">Estimated increased cost if you
                switch</span>
            </div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">&pound;{{elecSavingPerMonth()}}</div>
          </div>
        </div>
      </div>
    </mat-tab>
    }

    @if (data?.selectedQuote?.Fuels?.Gas) {
    <mat-tab [id]="id + '_Gas'">
      <ng-template mat-tab-label>Gas</ng-template>

      <div class="m-3">
        <h3 class="fs-20 fw700 mb-3">Tariff information</h3>
        <div class="text-center-xs fs-17">
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }">&nbsp;</div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50"><span class="fw700">New tariff</span></div>
              <div class="w-50"><span class="fw700">Current tariff</span></div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Supplier</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">{{data?.selectedQuote?.SupplierName}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.SupplierName}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Tariff</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">{{data?.selectedQuote?.TariffName}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.TarrifName}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Tariff
                type</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">{{data?.selectedQuote?.TarrifType}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.TarrifType}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Payment
                method</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.PaymentMethodText}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.PaymentMethodText}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Unit rate</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.UnitRate}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.UnitRate}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Night rate</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.NightUnitRate}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.NightUnitRate}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Standing
                charges</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.StandingCharge.split('(')[0]}}<br />
                {{data?.selectedQuote?.Fuels?.Gas?.StandingChargerPerYear}} per year
                <!-- £86.71 per year -->
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.StandingCharge.split('(')[0]}}<br />
                {{currentSupplier?.Fuels?.Gas?.StandingChargerPerYear}} per year
                <!-- £86.71 per year -->
              </div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Exit fees</span>
            </div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{data?.selectedQuote?.Fuels?.Gas?.ExitFee}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                &pound;{{currentSupplier?.Fuels?.Gas?.ExitFees}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Discount and
                additional charges</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.DiscountsAndAdditionalCharges[0].DiscountDesc}}
              </div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.Discounts === 0 ? '£0' :
                currentSupplier?.Fuels?.Gas?.Discounts}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Additional
                products included</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.AdditionalProductsIncluded}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.AdditionalProductsIncluded}}
              </div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Price guaranteed
                until</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill align-items-center">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.PriceGuaranteedUntil}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.PriceGuaranteedUntil}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
          <div class="mb-3 d-flex gap-3 w-100 align-items-center">
            <div class="first" [ngClass]="{ 'w-30': isTablet, 'w-25': !isTablet }"><span class="fw700">Tariff ends
                on</span></div>
            <div class="w-75 d-flex justify-content-start justify-content-lg-center gap-3 flex-fill">
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{data?.selectedQuote?.Fuels?.Gas?.TarrifEndDate}}</div>
              <div class="w-50 sessioncamexclude sessioncamhidetext maskpii">
                {{currentSupplier?.Fuels?.Gas?.TarrifEndDate}}</div>
            </div>
          </div>
          <div class="seprator8 mb-4"></div>
        </div>

        <div class="pb-4">
          <div class="d-none d-md-block">&nbsp;</div>
          <h3 class="fs-20 fw700 mb-3">Your potential savings</h3>
          <div class="d-flex mb-2">
            <div class="w44 w-sm-65"><span class="fw700">Your current monthly usage:</span></div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">
              {{gasCurrentUsageMonthly()}}Kwh</div>
          </div>
          <div class="d-flex mb-2">
            <div class="w44 w-sm-65"><span class="fw700">Your current monthly payment:</span></div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">
              &pound;{{currentSupplier?.Fuels?.Gas?.EstimatedMonthlyCost}}</div>
          </div>
          <div class="seprator8 mb-2"></div>
          <div class="d-flex mb-2">
            <div class="w44 w-sm-65"><span class="fw700">With this tariff you could pay:</span></div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">
              &pound;{{data?.selectedQuote?.Fuels?.Gas?.EstimatedMonthlyCost}}</div>
          </div>
          <div class="d-flex mb-3">
            <div class="w44 w-sm-65">
              <span class="fw700" *ngIf="!isNegativeNumber(gasSavingPerMonth())">Estimated savings if you
                switch:</span>
              <span class="fw700" *ngIf="isNegativeNumber(gasSavingPerMonth())">Estimated increased cost
                if you switch</span>
            </div>
            <div class="sessioncamexclude sessioncamhidetext maskpii">&pound;{{gasSavingPerMonth()}}</div>
          </div>
        </div>
      </div>
    </mat-tab>
    }
  </mat-tab-group>

  <div class=" mb-4">
    <mat-accordion class="example-headers-align accordionTyp2" multi>
      <ng-container>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title [id]="id + '_YourPotentialSavings_HowAreTheseSavingsCalculated'" class="elink">
              How are these savings calculated?
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="fs-17 ps-3" markdown [data]="content?.savingCalculated"></div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title [id]="id + '_YourPotentialSavings_' + data?.selectedQuote?.SupplierName" class="elink">
              About <span class="text-capitalize">{{data?.selectedQuote?.SupplierName}}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="fs-17 ps-3">
            <div>
              <h3 class="fs-20 fw700 mb-3">About the provider</h3>
              <div class="fs-17 mb-4">
                {{data?.selectedQuote?.Details}}
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>
  </div>

  <!-- Showing the promition banner only for the switchable Quotes -->
  @if (data?.selectedQuote.isSwitchable) {
  <div class="m-2 p-3 promotionalBox">
    <div class="d-flex flex-column w-75 promotional-content">
      <div class="titleTyp3 col4 mkd-title mb-3" markdown [data]="content?.claimRewards?.title"></div>
      <div class="fs-23 fw400 reduceXS text-col35 lh-1 mkd-para" markdown [data]="content?.claimRewards?.content"></div>
    </div>
  </div>
  }

  <div class="sticky-bottom bg-white">
    <mat-dialog-actions align="center" class=" text-center p-4">
      @if (data?.selectedQuote.isSwitchable) {
      <button [id]="id + '_SwitchNow'" class="btn btn-primary" mat-button mat-dialog-close
        (click)="switchNow(data?.selectedQuote)">
        {{ data?.selectedQuote?.isRetention ? 'Fix rate' : 'Switch now'}}
      </button>
      } @else {
      <span class="d-lg-inline-block d-block text-center">Contact the supplier</span>
      }
    </mat-dialog-actions>
  </div>
</div>